import React, { useEffect } from "react";
import "../styles/Toast.css";

function Toast({ message, type = "info", onClose, duration = 2000 }) {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose();
        const event = new CustomEvent('toastClosed');
        window.dispatchEvent(event);
      }, duration);


      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);


  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        <span>{message}</span>

      </div>
    </div>
  );
}

export default Toast;
